import { PropsWithChildren } from 'react'
import styles from './ArticleIntro.module.scss'

const ArticleIntro = ({ children }: PropsWithChildren) => {
  return <div className={styles['article-intro']}>{children}</div>
}

export default ArticleIntro
